export const breakpoints = {
  xs: '0px',
  sm: '600px',
  smPlus: '680px',
  tablet: '760px',
  md: '960px',
  mdPlus: '1100px',
  lg: '1280px',
  xl: '1920px',
}

export const media = {
  xs: `@media (min-width: ${breakpoints.xs})`,
  sm: `@media (min-width: ${breakpoints.sm})`,
  smPlus: `@media (min-width: ${breakpoints.smPlus})`,
  tablet: `@media (min-width: ${breakpoints.tablet})`,
  md: `@media (min-width: ${breakpoints.md})`,
  mdPlus: `@media (min-width: ${breakpoints.mdPlus})`,
  lg: `@media (min-width: ${breakpoints.lg})`,
  xl: `@media (min-width: ${breakpoints.xl})`,
}
